module.exports = __webpack_public_path__ + "img/d6.835ec946.png";